import request from '@/utils/request'

export function page(params) {
  return request({
    url: '/api/bdMainPort/page',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/api/bdMainPort',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/api/bdMainPort',
    method: 'put',
    data
  })
}

export function batchDel(ids) {
  return request({
    url: '/api/bdMainPort/batch',
    method: 'delete',
    data: ids
  })
}

export function getById(id) {
  return request({
    url: '/api/bdMainPort',
    method: 'get',
    params: {
      id
    }
  })
}

export function options() {
  return request({
    url: '/api/bdMainPort/options',
    method: 'get',
  })
}
